import React from 'react';
import PropTypes from 'prop-types';
import { css } from 'emotion';
import RIEBase from 'components/core/editable/RIEBase';
import { Checkbox, CheckboxGroup } from 'react-checkbox-group';

const verticalStyle =  css`
    display: block;
    margin: 5px 0 10px 0;
`;
const verticalFirstElementStyle = css`
    display: block;
    margin: 0 0 10px 0;
`;

/**
 * Editable component for a group of check boxes.
 * Component value is an array of objects 
 * { 
 *    key: string, 
 *    label: string || Component, 
 *    checked: bool
 * }
 */
export default class RIECheckboxSelect extends RIEBase {
    static propTypes = Object.assign({
        vertical: PropTypes.bool

    }, RIEBase.propTypes);

    onChange = (checkedItems) => {
        const newValue = this.getNewValue().map((value) => {
            const checked = checkedItems.includes(value.key);
            return { key: value.key, label: value.label, checked };
        });

        this.setState({ newValue });
    };

    _getCheckedValues = () => {
        const values = this.getNewValue();
        const checkedValues = values.filter((value) => {
            return value.checked;
        }).map((value) => {
            return value.key;
        });
        return checkedValues;
    };

    _getCheckboxNodes = () => {
        const values = this.getNewValue();
        const checkboxNodes = values.map((value, index) => {
            let style = null;
            if (this.props.vertical) {
                if (index === 0) {
                    style = verticalFirstElementStyle;
                } else {
                    style = verticalStyle;
                }
            }
            return (
                <span className={style} key={value.key}>
                    <label className={css`font-weight: normal; :hover{ cursor: pointer; }`}>
                        <Checkbox value={value.key} />
                        {value.label}
                    </label>
                </span>
            );
        });
        return checkboxNodes;
    };

    renderReadComponent = () => {
        // add onFocus back in order to go into edit mode via tab key then refactor RIE base so context menu will still work
        // onFocus={this.startEditing}
        return (
            <span
                className={`checkbox-wrapper ${this.makeClassString()}`}
                {...this.getStartEditingProps()}
                {...this.props.defaultProps}
            >
                <CheckboxGroup
                    tabIndex="0"
                    name="rie-checkbox-group"
                    readOnly
                    value={this._getCheckedValues()}
                >
                    {this._getCheckboxNodes()}
                </CheckboxGroup>

            </span>
        );
    };

    renderEditingComponent = () => {
        return (
            <div className={`checkbox-wrapper edit-mode ${this.makeClassString()}`}
                {...this.props.editProps}
            >
                <CheckboxGroup
                    tabIndex="1"
                    name="rie-checkbox-group"
                    ref="input"
                    value={this._getCheckedValues()}
                    onChange={this.onChange}
                    {...this.props.defaultProps}
                >
                    {this._getCheckboxNodes()}
                </CheckboxGroup>
            </div>
        );
    };

}



// WEBPACK FOOTER //
// ./src/components/core/editable/RIECheckboxSelect.js